import cn from 'classnames';
import React, { memo } from 'react';

import { useIsMobile } from '@sravni/react-utils';

import { useBranding } from '@src/reducers/branding';

import { useHeadingTexts } from '../hooks';

import style from './style.module.scss';

export const PageHeaderSubHeading: React.FC = memo(() => {
  const isMobile = useIsMobile();
  const { desktop, mobile } = useBranding() || {};
  const { creditCalculator = {} } = (isMobile ? mobile : desktop) || {};
  const { mainTextColor, regionTextColor } = creditCalculator;
  const replacements = useHeadingTexts().subHeadingText;

  const subHeader = React.useMemo(() => replacements, [replacements]);

  const componentStyle = React.useMemo(
    () =>
      ({
        '--branding-text-color': regionTextColor || mainTextColor,
      }) as React.CSSProperties,
    [mainTextColor, regionTextColor],
  );

  return (
    <div className={cn(style.wrapper)} style={componentStyle} data-qa="SeoMiniText">
      <div
        className={cn(style.text, {
          [style.textColor]: regionTextColor || mainTextColor,
        })}
      >
        {subHeader}
      </div>
    </div>
  );
});
